import { CloudProjectMetadata } from "@domain/project/cloud-project-metadata";
import type { ScopedProject } from "@domain/project/project-guards";
import { IsOptional } from "class-validator";

export class ProjectResponseDto {
  @IsOptional()
  project: ScopedProject | undefined;

  @IsOptional()
  metadata: CloudProjectMetadata | undefined;
}
